export enum ORDER_TYPES {
  SERVICE_BOOKING_MEMBERSHIP = 'SERVICE_BOOKING_MEMBERSHIP',
  SERVICE_BOOKING_APPOINTMENT = 'SERVICE_BOOKING_APPOINTMENT',
  SERVICE_BOOKING_CLASS = 'SERVICE_BOOKING_CLASS',
  SERVICE_BOOKING_EVENT = 'SERVICE_BOOKING_EVENT',
  EVENTS = 'EVENTS',
}
